import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, OnInit, DestroyRef, inject, EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CoreModule } from 'app/modules/core.module';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormBuilder, Validators } from '@angular/forms';
import { BankService } from '@services/banks.service';
import { InsuredService } from '@services/insured.service';

@Component({
  selector: 'app-bank-account-form',
  standalone: true,
  imports: [CoreModule, NgSelectComponent],
  providers: [BankService, InsuredService],
  templateUrl: './bank-account-form.component.html',
  styleUrls: ['./bank-account-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountFormComponent implements OnInit {
  @Input() insuredId: string
  @Input() inlineForm = true
  @Output() save = new EventEmitter<any>()
  @Output() cancel = new EventEmitter<void>()
  @Output() back = new EventEmitter<void>()

  private _bankService = inject(BankService)
  private _insuredService = inject(InsuredService)
  private fb = inject(FormBuilder)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  protected listBanks = []
  protected listTypeAccount = []
  protected bankAccountForm: any

  ngOnInit(): void {
    this.bankAccountForm = this.fb.group({
      insuredId: [this.insuredId, [Validators.required]],
      bankId: [null],
      accountTypeId: [null],
      number: [null]
    })
    this.getBanks()
    this.getTypeAccounts()
    if (this.insuredId) this.loadExisting()
  }

  private loadExisting(): void {
    this._insuredService.getBankAccount(this.insuredId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res) this.bankAccountForm.patchValue(res)
      this.cdr.markForCheck()
    })
  }

  private getBanks(): void {
    this._bankService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.listBanks = res; this.cdr.markForCheck() })
  }

  private getTypeAccounts(): void {
    this._bankService.getTypeAccount().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.listTypeAccount = res; this.cdr.markForCheck() })
  }

  submit(): void {
    if (this.bankAccountForm.valid) {
      this.save.emit(this.bankAccountForm.value)
    } else {
      this.bankAccountForm.markAllAsTouched()
    }
  }
}
